module.exports = __webpack_public_path__ + "static/media/allert-location.618a0909.png";